import React from 'react';
import WalletPage from './WalletPage';

const WalletPageWrapper: React.FC = () => {
  return <WalletPage />;
};

export default WalletPageWrapper;
